import { InternalAxiosRequestConfig } from 'axios';
import { useMemo } from 'react';

import { useAppSelector } from '@store';

export const useRequestFadcodeInterceptor = () => {
  const { fadcode } = useAppSelector((state) => state.branchInfo);

  const requestFadcodeInterceptor = useMemo(
    () => [
      // onFulfilled
      async (config: InternalAxiosRequestConfig) => {
        if (fadcode) {
          config.headers.fadcode = fadcode;
        }
        return config;
      },
      // onRejected
      // Has to be `any` type as this is the type Axios expects, and it does not accept generic types for the error type
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      (error: any) => Promise.reject(error),
    ],
    [fadcode],
  );

  return { requestFadcodeInterceptor };
};
